import { render } from "./AdminAddClientB2C.vue?vue&type=template&id=8f0274a8&scoped=true"
import script from "./AdminAddClientB2C.vue?vue&type=script&lang=js"
export * from "./AdminAddClientB2C.vue?vue&type=script&lang=js"

import "./AdminAddClientB2C.vue?vue&type=style&index=0&id=8f0274a8&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0274a8"]])

export default __exports__